import React from 'react'

const ColumnHiding = ({ setIsModalOpen, columns }) => {
  return (
    <>
      <div className="modalContent mx-auto w-1/2">
        {columns.map(
          (column) =>
            !column.hiddenHeader && (
              <div key={column.id} className="text-start">
                <label>
                  <input
                    type="checkbox"
                    className="accent-onTrack-emerald"
                    {...column.getToggleHiddenProps()}
                  />{' '}
                  {column.Header}
                </label>
              </div>
            )
        )}
      </div>
      <div className="modalActions">
        <div className="actionsContainer">
          <button className="cancelBtn " onClick={() => setIsModalOpen(false)}>
            Close
          </button>
        </div>
      </div>
    </>
  )
}

export default ColumnHiding
